import { createWebHashHistory, createRouter } from 'vue-router'
import Home from '../components/home'
import Show from "../components/show"
import Info from "../components/info"
import EPK from "../components/epk"
import Contact from "../components/contact"


const routes = [
    {
        path: "/",
        component: Home
    },
    {
        path: "/contact",
        component: Contact
    },
    {
        path: "/epk",
        component: EPK
    },
    {
        path: "/show",
        component: Show
    },
    {
        path: "/info",
        component: Info
    }
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
	scrollBehavior() {
		// Always scroll to top
		return { top: 0 };
	}
});

export default router;